export default __webpack_public_path__ + "static/media/742.50ba316d.gif";